import { IntroWrapper } from '../__intro-elements';
import { IntroKeys } from '../intro-keys';

export const FinalCutsList = () => (
  <IntroWrapper size="medium">
    <p>
      <b>Final Cuts List:</b> Here you'll see all your rendered videos. You may have multiple Final Cuts from different
      projects or re-renders.
    </p>
    <p>Select any Final Cut to preview it and access the available actions like upgrade, download, and share.</p>
    <p>
      <i>
        Tip: Your storyboards are read-only here. If you need to make changes, navigate back to the Storyboard page.
      </i>
    </p>
  </IntroWrapper>
);

export const FinalCutsPreview = () => (
  <IntroWrapper size="medium">
    <p>
      <b>Preview:</b> Watch your Final Cut here before deciding what to do with it.
    </p>
    <p>
      The player shows your rendered video exactly as it will appear when shared or downloaded. Take your time to review
      the quality and timing.
    </p>
  </IntroWrapper>
);

export const FinalCutsUpgrade = () => (
  <IntroWrapper size="medium">
    <p>
      <b>Upgrade Your Final Cut:</b> This is where you can enhance your video quality and remove limitations.
    </p>
    <p>
      <b>Upgrade options include:</b>
    </p>
    <ul>
      <li>Remove watermarks and branding</li>
      <li>Increase video resolution and quality</li>
      <li>Access premium export formats</li>
      <li>Unlock advanced editing features</li>
    </ul>
    <p>
      <i>Tip: Upgraded videos maintain the same great editing but with professional-grade output quality.</i>
    </p>
  </IntroWrapper>
);

export const FinalCutsDownload = () => (
  <IntroWrapper size="medium">
    <p>
      <b>Download:</b> Save your Final Cut to your computer for offline viewing or further editing.
    </p>
    <p>
      You can also use the download utility directly on the player controls. Downloaded videos are yours to keep and use
      however you like.
    </p>
  </IntroWrapper>
);

export const FinalCutsShare = () => (
  <IntroWrapper size="medium">
    <p>
      <b>Share:</b> Share your Final Cut directly to social media platforms.
    </p>
    <p>
      Pulse makes it easy to share your creations with friends, family, or your audience. Your videos are optimized for
      each platform's requirements.
    </p>
  </IntroWrapper>
);

// Mapping of intro keys to their corresponding tutorial components
const FINALCUTS_TUTORIALS = {
  [IntroKeys.fcElem]: FinalCutsList,
  [IntroKeys.fcPlay]: FinalCutsPreview,
  [IntroKeys.fcUpgrade]: FinalCutsUpgrade,
  [IntroKeys.fcDownload]: FinalCutsDownload,
  [IntroKeys.fcShare]: FinalCutsShare,
};

// Helper function to get tutorial steps for a given intro key
export const getFinalCutsTutorial = (introKey: IntroKeys) => {
  const TutorialComponent = FINALCUTS_TUTORIALS[introKey as keyof typeof FINALCUTS_TUTORIALS];
  if (!TutorialComponent) return null;
  return [{ element: `[data-intro="${introKey}"]`, intro: <TutorialComponent /> }];
};

// Helper function to check if an intro key is a final cuts tutorial
export const isFinalCutsTutorial = (introKey: IntroKeys) => {
  return introKey in FINALCUTS_TUTORIALS;
};
